import type { AgentConfigurationVersion } from '@/queries/agent-configuration-versions';
import type { FormInstance } from 'antd/es/form';
import React from 'react';
import styled from 'styled-components';

import { ExecutionConfigSection } from './ExecutionConfigSection';
import { LLMConfigSection } from './LLMConfigSection';
import { SchemasConfigSection } from './SchemasConfigSection';
import { ToolsConfigSection } from './ToolsConfigSection';

const EditorContainer = styled.div`
  padding: 0;
`;

interface ConfigurationEditorProps {
  config: Pick<
    AgentConfigurationVersion,
    | 'instructions'
    | 'inputSchema'
    | 'outputSchema'
    | 'toolConfig'
    | 'executionConfig'
    | 'llmConfig'
    | 'systemPrompt'
  >;
  versionId?: string;
  form: FormInstance;
  onChange: (
    config: Pick<
      AgentConfigurationVersion,
      | 'instructions'
      | 'inputSchema'
      | 'outputSchema'
      | 'toolConfig'
      | 'executionConfig'
      | 'llmConfig'
      | 'systemPrompt'
    >,
  ) => void;
  onFormChange?: () => void;
  activeSection?: 'execution' | 'llm' | 'tools' | 'schemas' | null;
}

export const ConfigurationEditor: React.FC<ConfigurationEditorProps> =
  React.memo(({ config, versionId, activeSection }) => {
    // Render the appropriate section based on activeSection
    switch (activeSection) {
      case 'execution':
        return (
          <EditorContainer>
            <ExecutionConfigSection config={config} versionId={versionId} />
          </EditorContainer>
        );

      case 'llm':
        return (
          <EditorContainer>
            <LLMConfigSection config={config} versionId={versionId} />
          </EditorContainer>
        );

      case 'tools':
        return (
          <EditorContainer>
            <ToolsConfigSection config={config} versionId={versionId} />
          </EditorContainer>
        );

      case 'schemas':
        return (
          <EditorContainer>
            <SchemasConfigSection config={config} versionId={versionId} />
          </EditorContainer>
        );

      default:
        return null;
    }
  });

ConfigurationEditor.displayName = 'ConfigurationEditor';
